import { RequestType } from '@cornerstonejs/core/enums';

import loadImageToCanvas from './loadImageToCanvas';

/**
 * @param {*} cornerstone
 * @param {*} imageId
 */
const getImageSrcFromImageId = (cornerstone, imageId) => {
	return new Promise((resolve, reject) => {
		const canvas = document.createElement('canvas');
		// TODO: lỗi không load được thumbnail nếu truyền trùng imageId khi tách series
		loadImageToCanvas({ canvas, imageId, thumbnail: false, requestType: RequestType.Interaction })
			.then((_imageId) => {
				resolve(canvas.toDataURL());
			})
			.catch(reject);
	});
};

export default getImageSrcFromImageId;
